import { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { Typography, useTheme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";

export default function DropZone({ saveFile, label }) {
  const theme = useTheme();
  const matches = useMediaQuery("(min-width:600px)");
  const onDrop = useCallback((acceptedFiles) => {
    saveFile(acceptedFiles[0]);
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: false,
    accept: [".jpg", ".png", ".jpeg", ".JPG", ".PNG", ".JPEG"],
    maxSize: 2 * 1024 * 1024,
  });

  return (
    <div
      {...getRootProps()}
      style={{
        height: "100px",
        justifyContent: "center",
        alignItems: "center",
        width: "-webkit-fill-available",
        border: "dashed",
        backgroundImage: "url(/upload.png)",
        padding: "20px",
        margin: "30px",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        borderColor: "#182d04",
        backgroundColor: "#4b8c0e",
        borderRadius: "10px",
        backgroundSize: "contain",
        position: "relative",
      }}
    >
      <label style={{ position: "absolute", top: "-1.5rem" }}>
        {label && matches ? `${label} de  hasta 2mb` : label}
      </label>
      <input {...getInputProps()} />
      <Typography
        variant="subtitle2"
        textAlign="center"
        style={{ padding: 20 }}
      >
        {/* {isDragActive
          ? "Arroja aqui tus archivos"
          : "Arrastra aqui o click para agregar una foto"} */}
      </Typography>
      <label style={{ position: "absolute", bottom: "-1.5rem" }}>
        {label && matches
          ? `${label} - Archivos aceptados ".jpg", ".png", ".jpeg",
        ".JPG", ".PNG", ".JPEG"`
          : "Archivos de hasta 2 MB"}
      </label>
    </div>
  );
}
